<template>
  <v-row>
    <v-col offset-md="1" md="10" sm="12">
      <div class="text-h4 theme-text mb-4">
        Hello {{ userInfo.username.split(" ")[0] }} !
      </div>
      <!--      <v-breadcrumbs :items="breadcrumbs" divider=">" class="pl-1 pb-0"/>-->
      <v-row>
        <v-col lg="8" sm="12">
          <v-card class="mb-2">
            <v-card-title class="theme pb-0">
              <v-icon class="white--text">timeline</v-icon>
              <span class="ml-2 headline font-weight-regular white--text">Whats happening</span>
            </v-card-title>
            <v-card-text class="theme py-1">
              <v-tabs
                  dark
                  show-arrows
                  v-model="tab"
                  class="theme white--text"
                  align-with-title
                  background-color="#551738"
              >
                <v-tabs-slider color="white"></v-tabs-slider>
                <v-tab href="#everything" class="theme white--text">view all</v-tab>
                <v-tab href="#birthdays" class="theme white--text">celebrations</v-tab>
                <v-tab href="#timeoffs" class="theme white--text">who's out</v-tab>
                <v-tab href="#holidays" class="theme white--text">public holidays</v-tab>

              </v-tabs>
            </v-card-text>
            <v-card-text>
              <v-tabs-items v-model="tab">
                <v-tab-item :value="'everything'">
                  <div class="mb-3 mt-n1">A summary of upcoming birthdays, anniversaries, who’s out of office and public holidays for the next two weeks</div>
                  <activities-everything
                      :everything="dashboard.activities.everything"
                  />
                </v-tab-item>
                <v-tab-item :value="'birthdays'">
                  <div class="mb-3 mt-n1">Party time! Quick overview of upcoming birthdays and work anniversaries.</div>
                  <activities-anniversary
                      :anneversaries="dashboard.activities.anniversary"
                  />
                </v-tab-item>
                <v-tab-item :value="'timeoffs'">
                    <div class="mb-3 mt-n1">See who’s on vacation, sick or out of office for the upcoming 14 days. You can also check out the <router-link to="/company/calendars"> company calendar</router-link>.</div>
                  <activities-timeoff
                      :timeoffs="dashboard.activities.time_off"
                  />
                </v-tab-item>
                <v-tab-item :value="'holidays'">
                  <div class="mb-3 mt-n1">Plan for upcoming public holidays. The <router-link to="/company/calendars"> company calendar</router-link> is also a good place to check out.</div>
                  <div v-if="!dashboard.calendar && userInfo.role === 'HR'">
                    <div class="ml-4 mb-4">
                      You have not setup a calendar for the company yet. Please
                      setup a calendar for your organization.
                    </div>
                    <v-btn
                        depressed
                        small
                        @click="calendars"
                        color="ml-3 action rounded-sm white--text"
                    >setup calendar
                    </v-btn
                    >
                  </div>
                  <activities-holidays
                    v-else
                    :holidays="dashboard.activities.holidays"
                  />
                </v-tab-item>
              </v-tabs-items>
            </v-card-text>
          </v-card>

          <v-card class="mb-2">
            <v-card-title>
              <v-icon class="darkertext">volume_up</v-icon>
              <span class="ml-2 headline font-weight-regular darkertext">Recent company announcements</span>
            </v-card-title>
            <v-divider />
            <v-card-text class="mt-0">
              <div
                v-if="
                  !dashboard.announcements ||
                  dashboard.announcements.length === 0
                "
                class="grey--text text--darken-2"
              >
                <div class="pl-3">No recent announcements !</div>
              </div>
                <v-timeline v-else align-top dense>      
                  <v-timeline-item
                    color="white"
                    fill-dot
                    v-for="item in dashboard.announcements"
                    :key="item.id"
                    small
                    @click.native.stop="routeToAnnouncement(item)"                   
                  >                 
                    <template v-slot:icon >
                      <v-avatar size="55">
                        <v-img v-if="item.url" :src="item.url" />
                        <v-btn fab v-else depressed class="action">
                          <v-icon class="white--text">volume_up</v-icon>
                        </v-btn>
                      </v-avatar>
                    </template>
                    <v-hover v-slot="{ hover }">
                      <div class="mt-n4" :class="{ 'hovered': hover }">
                        <div class="font-weight-normal title" :class="{ 'hovered': hover }">
                          <strong class="grey--text text--darken-3" >{{
                            item.title
                          }}</strong>
                        </div>
                        <div class="font-weight-normal mt-0">
                          <strong>{{ item.user_name }}</strong>
                        </div>
                        <div>{{ item.date }}</div>
                      </div>
                    </v-hover>
                  </v-timeline-item>                
                </v-timeline>            
            </v-card-text>
          </v-card>
        </v-col>

        <v-col lg="4" sm="12">
          <v-card class="mb-2">
            <v-card-title>
              <v-icon class="darkertext">view_list</v-icon>
              <router-link to="/tasks" class="header-link">
                <div>
                  <v-badge
                    offset-y="12"
                    offset-x="-3"
                    dot
                    color="#2bb1d0"
                    v-model="outstandingTasks"
                  >
                    <span class="ml-2 headline font-weight-regular darkertext">My tasks</span>
                  </v-badge>
                </div>
              </router-link>
            </v-card-title>
            <v-divider />
            <v-card-text class="mt-0">
              <div
                v-if="!dashboard.todos || dashboard.todos.length === 0"
                class="grey--text text--darken-2"
              >
                <div class="pl-3">Your pending tasks</div>
                <div class="pl-3">Nothing here !</div>
              </div>
              <div v-else>
                <v-list dense>
                  <v-list-item
                    class="my-n3"
                    v-for="(todo, i) in dashboard.todos"
                    :key="i"                    
                    @click="todoAction(todo)"
                  >                   
                    <v-list-item-avatar size="30" class="mr-1">
                      <v-icon
                        class="error--text"
                        small
                        v-if="todo.code === 'TIMEOFF'"
                      >
                        beach_access
                      </v-icon>
                      <v-icon
                        class="error--text"
                        small
                        v-if="todo.code === 'TODO'"
                      >
                        new_releases
                      </v-icon>
                    </v-list-item-avatar>
                    <v-hover v-slot="{ hover }">
                      <v-list-item-content :class="{ 'hovered': hover }">
                        <v-list-item-title
                          class="font-weight-normal grey--text text--darken-4"
                        >{{ todo.description }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-hover>
                  </v-list-item>
                </v-list>
              </div>
            </v-card-text>
          </v-card>
          <v-card class="mb-2">
            <v-card-title>
              <v-icon class="darkertext">beach_access</v-icon>
              <span class="ml-2 headline font-weight-regular darkertext"
                >My time off balance</span
              >
            </v-card-title>
            <v-divider />

            <v-card-text class="py-0">
              <v-row>
                <v-col cols="12">
                  <v-card flat>
                    <v-card-text>
                      <h1 class="display-2 text-xs-center">
                        {{ totalTimeoffs }}
                      </h1>
                      <div class="title text-xs-center mb-1">
                        vacation days available
                      </div>
                      <template v-if="availableTimeoffs">
                        <v-chip
                          v-for="(item, i) in availableTimeoffs"
                          :key="i"
                          class="mt-2 mr-2"
                          small
                          chip
                        >
                          {{ item.name }}: {{ item.days }}
                        </v-chip>
                      </template>
                    </v-card-text>
                  </v-card>
                </v-col>

                <v-col cols="12">
                  <v-list
                    dense
                    v-if="myTimeoffs && myTimeoffs.length > 0"
                    class="py-0 my-0"
                  >
                    <div class="title grey--text text--darken-3 text-xs-center mb-1 ml-3">
                      My upcoming time off
                    </div>
                    <v-list-item-group>
                      <v-list-item
                        two-line
                        v-for="(item, i) in myTimeoffs"
                        :key="i"
                      >
                        <v-list-item-content class="mt-n3 mb-n4">
                          <v-list-item-title class="theme-text subtitle-2 text-capitalize">{{
                            item.title
                          }}</v-list-item-title>
                          <v-list-item-subtitle>
                            {{ item.start.substring(0, 10) }} &nbsp;-&nbsp;{{
                              item.end.substring(0, 10)
                            }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                  <div
                    v-else
                    class="pb-4 text-md-subtitle-2 grey--text text--darken-3"
                  >
                    Nothing scheduled in the near future.
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="pt-0">
              <v-spacer />
              <v-btn
                small
                class="action rounded-sm white--text"
                depressed
                @click="timeoff"
                >Request time off</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col cols="12" sm="12" v-if="userInfo.role === 'HR'">
          <div class="text-h4 theme-text mb-4">Latest marketplace offers</div>
        </v-col>
        <v-col
          cols="12"
          md="4"
          v-for="benefit in dashboard.benefits"
          :key="benefit.id"
        >
          <div>
            <v-card>
              <v-img v-if="benefit.url" :src="benefit.url" height="200px" />
              <v-img
                v-else
                src="https://cdn.vuetifyjs.com/images/parallax/material2.jpg"
                height="200px"
              />
              <v-card-title>
                <div>
                  <h3 class="theme-text">{{ benefit.name }}</h3>
                  <div class="subtitle-1 font-weight-light">
                    Provider : {{ benefit.provider_name }}
                  </div>
                  <div class="subtitle-1 font-weight-light">
                    Category : {{ benefit.category }}
                  </div>
                </div>
              </v-card-title>

              <v-card-text>
                <div class="font-weight-bold mb-3 theme-text">
                  {{ benefit.title }}
                </div>
                <p>
                  {{
                    benefit.description && benefit.description.length > 30
                      ? benefit.description.substring(0, 30) + " ..."
                      : benefit.description
                  }}
                </p>
              </v-card-text>
              <v-card-actions>
                <v-btn text @click="showBenefit(benefit.id)" class="theme-text"
                  >read more</v-btn
                >
              </v-card-actions>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-col>

    <v-dialog v-model="dialog" max-width="550" persistent>
      <v-card>
        <v-card-title class="title theme-text">
          Hi {{ userInfo.username }} and welcome to {{ companyInfo.name }} !
        </v-card-title>
        <v-divider />
        <v-card-text class="my-4 body-1">
          It is great to have you on the team. Please take your time to explore
          the different options in LessAdmin. On this dashboard-page you will
          find an easy overview of the different outstanding tasks that you are
          requested to complete.
          <br/>
          <br/>
          Next step for you is to complete your profile information. Click
          <a href="/#/me">here</a> to start.
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn color="green darken-1" text @click="completeTNC">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import {mapGetters} from 'vuex';

import {Actions} from '@/views/actions';
import {Component} from '@/views/component';
import ActivitiesAnniversary from '@/views/protected/dashboard/activities-anniversary';
import ActivitiesEverything from '@/views/protected/dashboard/activities-everything';
import ActivitiesHolidays from '@/views/protected/dashboard/activities-holidays';
import ActivitiesTimeoff from '@/views/protected/dashboard/activities-timeoff';

export default {
  name: Component.Dashboard,
  components: {
    ActivitiesTimeoff,
    ActivitiesHolidays,
    ActivitiesEverything,
    ActivitiesAnniversary,
  },
  computed: {
    ...mapGetters([
      "userInfo",
      "companyInfo",
      "dashboard",
      "availableTimeoffs",
      "myTimeoffs",
      "everything",
      "empPopUpShown",
    ]),
    sidebarGradient() {
      return `to top right, ${this.sidebarBackgroundStart}, ${this.sidebarBackgroundEnd}`;
    },
    totalTimeoffs() {
      let count = 0;
      if (this.availableTimeoffs) {
        this.availableTimeoffs.forEach((el) => {
          if (el.type === "Vacation") {
            count += el.days;
          }
        });
      }
      return count;
    },
    outstandingTasks() {
      return this.dashboard.todos != null;
    },
  },
  data: () => ({
    dialog: false,
    sidebarBackgroundStart: "rgba(182,168,174,0.33)",
    sidebarBackgroundEnd: "rgba(27, 27, 27, 0.74)",
    alertType: "warning",
    alertShow: false,
    alertText: "",
    tab: null,
  }),
  methods: {
    getIconForEverythingSection(tt) {
      switch (tt) {
        case "announcement":
          return "volume_up";
        case "holiday":
          return "beach_access";
        case "timeoff":
          return "fact_check";
        case "birthday":
          return "cake";
        default:
          return "grade";
      }
    },
    getColorForEverythingSection(tt) {
      switch (tt) {
        case "announcement":
          return "action";
        case "holiday":
          return "pink";
        case "timeoff":
          return "save";
        case "birthday":
          return "theme";
        default:
          return "info";
      }
    },
    resetModels() {
      this.alertType = "info";
      this.alertShow = false;
      this.alertText = "";
    },
    showBenefit(id) {
      if (!id) return false;
      this.$router.push({
        name: Component.Protected.Benefit.OnBoarding,
        params: { id: id },
      });
    },
    setup() {
      this.resetModels();
      this.$store
        .dispatch("dashboard")
        .then(() => {
        if (this.dashboard.me && !this.dashboard.me.tnc_complete) {
          this.dialog = true;
        }
      })
        .catch(() => {
          this.$emit("handleAlert", {
            show: true,
            type: "error",
            message: "Unable to get dashboard details",
            component: null
          });
        });
    },
    timeoff() {
      this.$router.push({ name: Component.Protected.TimeOff.List });
    },
    marketplace() {
      this.$router.push({ name: Component.Protected.Benefit.Marketplace });
    },
    calendars() {
      this.$router.push({ name: Component.Protected.Company.Calendar.List });
    },
    todoAction(todo) {
      if (todo && !todo.done) {
        switch (todo.code) {
          case "DEPARTMENTS":
            this.$router.push({
              name: Component.Protected.Company.Departments.Add,
            });
            break;
          case "BENEFITS":
            this.$router.push({ name: Component.Protected.Benefit.Custom.Add });
            break;
          case "TIMEOFF":
            this.$router.push({ name: Component.Protected.TimeOff.Approve });
            break;
          case "PROFILE":
            this.$router.push({ name: Component.Protected.Employee.Me });
            break;
          case "ACTIVATE":
            this.$router.push({
              name: Component.Protected.Company.Membership.List,
            });
            break;
          case "COMPANY_INFO":
            this.$router.push({ name: Component.Protected.Company.General });
            break;
          case "CALENDAR":
            this.$router.push({
              name: Component.Protected.Company.Calendar.List,
            });
            break;
          case "TODO":
            this.$router.push({ name: Component.Protected.Employee.MyTasks });
            break;
          default:
            return false;
        }
      } else {
        return false;
      }
    },
    routeToAnnouncement(item) {
      if (!item || !item.id) {
        return false;
      }

      if (this.userInfo.role === "Employee") {
        this.$router.push({
          name: Component.Protected.Announcement.Read,
          params: {id: item.id},
        });
      } else {
        this.$router.push({
          name: Component.Protected.Announcement.Edit,
          params: {id: item.id},
        });
      }
    },
    completeTNC() {
      let payload = {
        id: parseInt(this.userInfo.userID),
        data: {
          tnc_complete: true,
          tnc_version: parseInt(this.dashboard.me.tnc_version) + 1,
        },
      };

      console.log(payload);

      this.$store.dispatch(Actions.Employee.Save, payload).then(r => {
        if (r.status === 200) {
          this.dialog = false;
        }
      });
    },
  },
  created() {
    if (this.userInfo && this.userInfo.username) {
      this.setup();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.setup());
    }
  },
  beforeDestroy() {
    this.resetModels();
  },
};
</script>

<style scoped>
* >>> .theme--light.v-tabs > .v-tabs-bar {
  background-color: #551738 !important;
  border-color: #551738 !important;
}

* >>> div.v-alert.warning {
  border-radius: 5px;
}

.border {
  border-radius: 3px !important;
  border: solid 1px rgba(194, 184, 184, 0.2);
}

* >>> div.v-slide-group__next > i,
* >>> div.v-slide-group__prev > i {
  color: #eceff1 !important;
}
.darkertext {
  color: #272929;
}
.hovered{ 
  transform: scale(1.01);
  cursor: pointer;
}
</style>
